import { ArcByAngles, ArcByEdge, FollowsGeoBorder, LineSegment, LineSegmentType } from "../../../core/geo/types";
import { isNumber } from "lodash";

interface SegmentValidator {
    validateSegment: (segment: LineSegment) => void;
}

const validateIndexSet = (segment: LineSegment) => {
    if (!segment.properties || !isNumber(segment.properties.index)) {
        throw new Error("Segment missing properties or 'index' attribute");
    }
};

const validatePointSet = (segment: LineSegment) => {
    if (!segment.properties.point) {
        throw new Error("Segment missing 'point' attribute");
    }
};

const greatCircleValidator: SegmentValidator = {
    validateSegment(segment: LineSegment) {
        validateIndexSet(segment);
        validatePointSet(segment);
    },
};

const arcByEdgeValidator: SegmentValidator = {
    validateSegment(segment: LineSegment) {
        const arcByEdge = segment as LineSegment<ArcByEdge>;
        validateIndexSet(arcByEdge);
        validatePointSet(arcByEdge);
        if (!arcByEdge.properties.arcPoint) {
            throw new Error("Segment missing 'arcPoint' attribute");
        }
    },
};

const arcByAnglesValidator: SegmentValidator = {
    validateSegment(segment: LineSegment) {
        const arcByAngles = segment as LineSegment<ArcByAngles>;
        validateIndexSet(arcByAngles);

        if (!arcByAngles.properties.center) {
            throw new Error("Segment missing 'center' attribute");
        }
        if (!isNumber(arcByAngles.properties.radius)) {
            throw new Error("Segment missing 'radius' attribute");
        }
        if (!isNumber(arcByAngles.properties.bearing1)) {
            throw new Error("Segment missing 'bearing1' attribute");
        }
        if (!isNumber(arcByAngles.properties.bearing2)) {
            throw new Error("Segment missing 'bearing2' attribute");
        }
    },
};

const followsGeoBorderValidator: SegmentValidator = {
    validateSegment(segment: LineSegment) {
        const followsGeoBorder = segment as LineSegment<FollowsGeoBorder>;
        validateIndexSet(followsGeoBorder);
        validatePointSet(followsGeoBorder);
        if (!followsGeoBorder.properties.geoBorderId) {
            throw new Error("Segment missing 'geoBorderId' attribute");
        }
    },
};

const validators: { [key in LineSegmentType]: SegmentValidator } = {
    GreatCircle: greatCircleValidator,
    ArcByEdge: arcByEdgeValidator,
    ArcByAngles: arcByAnglesValidator,
    FollowsGeoBorder: followsGeoBorderValidator,
};

export const validateSegments = (segments: LineSegment[]) => {
    segments.forEach((segment) => validators[segment.type].validateSegment(segment));
};
